import { twMerge } from "tailwind-merge";
import { clsx } from "clsx";
import type { ReactNode } from "react";

export type BadgeVariant = "default" | "success" | "warning" | "danger" | "info";

const STYLES: Record<BadgeVariant, string> = {
  default: "bg-border/50 text-text-secondary",
  success: "bg-success/15 text-success",
  warning: "bg-warning/15 text-warning",
  danger: "bg-danger/15 text-danger",
  info: "bg-info/15 text-info",
};

export default function Badge({
  variant = "default",
  children,
  className,
}: {
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={twMerge(
        clsx("inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium", STYLES[variant]),
        className,
      )}
    >
      {children}
    </span>
  );
}
